import rpc from './core'

const urls = {
  profile: {
    url: '/user/profile',
    method: 'GET'
  },
  updateProfile: {
    url: '/user/profile',
    method: 'POST'
  },
  updateAboutPriest: {
    url: '/user/priest',
    method: 'POST'
  },
  loadCountries: {
    url: '/user/countries',
    method: 'GET'
  },
  saveLocale: {
    url: '/user/locale',
    method: 'POST'
  },
  load_invites: {
    url: '/user/invites',
    method: 'GET'
  },
  generate_invite: {
    url: '/user/invites',
    method: 'POST'
  },
  send_feedback: {
    url: '/user/feedback',
    method: 'POST'
  }
}

const getProfile = async () => {
  return rpc({ ...urls['profile'] })
}
const updateProfile = async (profile) => {
  return rpc({ data: { profile }, ...urls['updateProfile'] })
}
const updateAboutPriest = async (about) => {
  return rpc({ data: { about }, ...urls['updateAboutPriest'] })
}
const loadCountries = async () => {
  return rpc({ ...urls['loadCountries'] })
}
const saveLocale = async (locale) => {
  return rpc({ data: { locale }, ...urls['saveLocale'] })
}
const loadInvites = async () => {
  return rpc({ ...urls['load_invites'] })
}
const generateInvite = async () => {
  return rpc({ ...urls['generate_invite'] })
}
const sendFeedback = async (message, recipient) => {
  return rpc({ data: { message, recipient }, ...urls['send_feedback'] })
}

export default { getProfile, updateProfile, updateAboutPriest, loadCountries, saveLocale, loadInvites, generateInvite, sendFeedback }
